<template>
  <div
    v-editable="blok"
    class="cms-text break-words"
    :class="[
      {
        'text-center': alignment === 'centered',
        'text-right': alignment === 'right',
        'text-justify': alignment === 'justify',
      },
      marginClasses,
    ]"
  >
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div
      :class="{
        'align-list': alignment === 'centered' || alignment === 'right',
      }"
      v-html="content"
    />
  </div>
</template>

<script lang="ts">
import type { SbText } from '~/cms/storyblok/types/storyblok.d.ts'
import useStoryblokMargins from '~/cms/storyblok/composables/useStoryblokMargins'
import useRichtext from '~/cms/storyblok/composables/useRichtext'

export default defineComponent({
  name: 'CmsText',
  props: {
    blok: {
      type: Object as PropType<SbText>,
      default: () => {},
    },
  },
  setup(props) {
    const { marginClasses } = useStoryblokMargins(props.blok)
    const { content } = useRichtext(props.blok.body as any)
    const alignment = computed(() => props.blok?.alignment || '')

    return {
      alignment,
      content,
      marginClasses,
    }
  },
})
</script>

<style lang="postcss">
.align-list ul,
.align-list ol {
  list-style-position: inside;
  padding-left: 0;
}
.cms-text h1 {
  @apply text-2xl
    font-medium
    leading-9
    mb-4
    md:mb-6
    md:text-3xl
    md:leading-10;
}
.cms-text h2 {
  @apply text-xl
    font-medium
    leading-8
    mb-4
    md:mb-6
    md:text-2xl
    md:leading-9;
}
.cms-text h3 {
  @apply text-lg
    font-normal
    leading-7
    mb-4
    md:mb-6
    md:text-xl
    md:leading-8;
}
.cms-text a {
  @apply text-black underline;
}
.cms-text button {
  @apply text-black underline font-medium;
}
.cms-text p {
  @apply text-base
    font-medium
    leading-5
    mb-4
    md:mb-6
    md:text-lg
    md:leading-7;
}
.align-list li p {
  display: inline;
}
.cms-text b {
  @apply font-bold;
}
.cms-text ul {
  @apply list-disc
  pl-6
  mb-4
  md:mb-6;
}
.cms-text ul li p {
  @apply mb-2;
}
.cms-text ol {
  @apply list-decimal
  pl-6
  mb-4
  md:mb-6;
}
.cms-text ol li p {
  @apply mb-2;
}
</style>
